export default "__VITE_ASSET__493bbfa3__"